import {Component, OnInit} from '@angular/core';
import {MstVisitService} from '../configuration/mst-visit/mst-visit.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MstUnitService} from '../configuration/mst-unit/mst-unit.service';
import {TranslateService} from 'ng2-translate';
import {Aarogyam, COVID, GrandPort, hind, Iilds, Karad, MataPita, Medikal, MK, Nepal, Shatabdi2, ssnj, SSPM, swaraj, Tata, Tawau, Turkish, vishvateja, YCM, Yogita} from '../shared/my-constants';
import {TemrVitalService} from '../configuration/temr-vital/temr-vital.service';
import {MbillServiceService} from '../configuration/mbill-service/mbill-service.service';
import {TbillBillServiceService} from '../billing/tbill-bill-service/tbill-bill-service.service';
import {TemrVisitDiagnosisService} from '../configuration/temr-visit-diagnosis/temr-visit-diagnosis.service';

@Component({
    selector: 'app-casepaper',
    templateUrl: './casepaper.component.html',
    styleUrls: ['./casepaper.component.css']
})
export class CasepaperComponent implements OnInit {
    private visit_id: any;
    private bsId: any;
    private currentPatient: any = {};
    private currentService: any = {};
    private currentPatientId: any;
    private currentVisit: any = {};
    mstUnit: any = {};
    unitid: any;
    currentUserdetails: any;
    featuredate: Date;
    currDate:any = new Date();
    iilds: Boolean = Iilds;
    nepal: Boolean = Nepal;
    tawau: Boolean = Tawau;
    sspm: Boolean = SSPM;
    covid: Boolean = COVID;
    tata: Boolean = Tata;
    aarogyam: Boolean = Aarogyam;
    turkish: Boolean = Turkish;
    medikal: Boolean = Medikal;
    mk: Boolean = MK;
    grandPort: Boolean = GrandPort;
    karad: Boolean = Karad;
    matapita: Boolean = MataPita;
    ycm: Boolean = YCM;
    yogita: Boolean = Yogita;
    ssnj: Boolean = ssnj;
    swaraj: Boolean = swaraj;
    hind: Boolean = hind;
    Shatabdi: Boolean = Shatabdi2;
    vishvateja: Boolean = vishvateja;
    vitalDetails: any = {};
    visitDiagnosis: any = {};

    constructor(
        private router: Router,
        private translateService: TranslateService,
        private route: ActivatedRoute,
        private mstVisitService: MstVisitService,
        private mstUnitService: MstUnitService,
        private temrVitalService: TemrVitalService,
        private tbillBillServiceService: TbillBillServiceService,
        private temrVisitDiagnosisService: TemrVisitDiagnosisService) {
    }

    ngOnInit() {
        this.unitid = JSON.parse(sessionStorage.getItem('unitId'));
        this.currentUserdetails = JSON.parse(sessionStorage.getItem('userdetail'));
        this.route.params.subscribe((params: any) => {
            this.visit_id = params['visit_id'];
        });
        this.route.params.subscribe((params: any) => {
            this.bsId = params['bsId'];
            this.tbillBillServiceService.getTbillBillServiceByBsId(this.bsId).then(resp=>{
                this.currentService = resp;
                console.log('this.currentService ', this.currentService);
            });
        });
        this.vitalDetails = '';
        this.temrVitalService.getRecordServiceByVisitId(this.visit_id).then(resp => {
            console.log('getVitaldetailsByPatientId ', resp);
            this.vitalDetails = resp;
            console.log('this.temrVitalList ', this.vitalDetails);
        });
        // this.temrVisitDiagnosisService.getAllRecordServicebyVisitId(1, 100, this.visit_id, 'DESC', 'vdId').then(resp => {
        //     console.log('getAllRecordServicebyVisitId ', resp);
        //     this.visitDiagnosis = resp;
        //     console.log('this.visitDiagnosis ', this.visitDiagnosis);
        // });
        this.featuredate = new Date();
        this.featuredate.setDate(this.featuredate.getDate() + 2);
        // console.log("Login User :"+ this.visit_id);
        this.getUnitDetailsById(this.unitid);
        this.getVisit();
    }

    getVisit() {
        this.unitid = JSON.parse(sessionStorage.getItem('unitId'));
        this.mstVisitService.getRecordService(this.visit_id).then(resp => {
            this.currentPatient = resp.visitPatientId;
            this.currentPatientId = resp.visitPatientId.patientId;
            this.currentVisit = resp;
            console.log("hello",this.currentVisit);
            // this.getUnitDetailsById(this.unitid);
        });
    }

    getUnitDetailsById(id: any) {
        this.mstUnitService.getRecordService(id)
            .then(resp => {
                this.mstUnit = resp;
                // console.log("unit details");
                // console.log(resp);
            });
    }

    navigateBack() {
        this.router.navigate(['/opd/queue']);
        this.vitalDetails = '';
    }

    printCasePaper(): void {
        let printContents, popupWin;
        printContents = document.getElementById('print-section').innerHTML;
        console.log(printContents);
        popupWin = window.open('', '', 'top=0,left=0,height=100%,width=auto, zoom=50%');
        popupWin.document.open();
        popupWin.document.write(`
      <html>
        <head>
          <title>Case Paper</title>
          <style>
          table{
         border: none !important; 
          /*margin-top: -35px;*/
          /*margin-left: -1.50% !important;*/
          }
          tr{
            width: 100%;
            padding:0px;margin:0px
          }
          .marpad{
         margin-right:30px;
         margin-top: 20px;
         margin-left: 5px;
          }
          .table>tbody>tr>td, .table>tbody>tr>th, .table>tfoot>tr>td, .table>tfoot>tr>th, .table>thead>tr>td, .table>thead>tr>th{
    border-top: none !important;
    font-size: 11px !important;
    padding:0px; margin:0px;
}

</style>
          
          <link rel="stylesheet" href="assets/css/your_style.css">
          
          
         <!-- Latest compiled and minified CSS -->
<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" integrity="sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u" crossorigin="anonymous">

<!-- Optional theme -->
<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap-theme.min.css" integrity="sha384-rHyoN1iRsVXV4nD0JutlnGaslCJuC7uwjduW9SVrLvRYooPp2bWYgmgJQIXwl/Sp" crossorigin="anonymous">

<!-- Latest compiled and minified JavaScript -->
<script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js" integrity="sha384-Tc5IQib027qvyjSMfHjOMaLkfuWVxZxUPnCJA7l2mCWNIpG9mGCD8wGNIcPD7Txa" crossorigin="anonymous" media='all'></script>
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
      </html>`
        );
        popupWin.document.close();
    }

    printCasePaper1(): void {
        let printContents, popupWin;
        printContents = document.getElementById('print-section1').innerHTML;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(`
      <html>
        <head>
        <style> 
        td{
            border: none !important;   
                 
        }
        </style>
          <link rel="stylesheet" href="assets/css/your_style.css">
         <!-- Latest compiled and minified CSS -->
<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" integrity="sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u" crossorigin="anonymous">

<!-- Optional theme -->
<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap-theme.min.css" integrity="sha384-rHyoN1iRsVXV4nD0JutlnGaslCJuC7uwjduW9SVrLvRYooPp2bWYgmgJQIXwl/Sp" crossorigin="anonymous">

<!-- Latest compiled and minified JavaScript -->
<script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js" integrity="sha384-Tc5IQib027qvyjSMfHjOMaLkfuWVxZxUPnCJA7l2mCWNIpG9mGCD8wGNIcPD7Txa" crossorigin="anonymous"></script>
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
      </html>`
        );
        popupWin.document.close();
    }

    printCasePaper2(): void {
        let printContents, popupWin;
        printContents = document.getElementById('print-section2').innerHTML;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          
          <link rel="stylesheet" href="assets/css/your_style.css">
          
         <!-- Latest compiled and minified CSS -->
<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" integrity="sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u" crossorigin="anonymous">

<!-- Optional theme -->
<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap-theme.min.css" integrity="sha384-rHyoN1iRsVXV4nD0JutlnGaslCJuC7uwjduW9SVrLvRYooPp2bWYgmgJQIXwl/Sp" crossorigin="anonymous">

<!-- Latest compiled and minified JavaScript -->
<script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js" integrity="sha384-Tc5IQib027qvyjSMfHjOMaLkfuWVxZxUPnCJA7l2mCWNIpG9mGCD8wGNIcPD7Txa" crossorigin="anonymous"></script>
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
      </html>`
        );
        popupWin.document.close();
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/casepaper/casepaper.component.ts